import { FC } from 'react';
import { alpha, Skeleton, Stack } from '@mui/material';
import { type SavedReply } from '@vs-online-only-app/state';
import styled from 'styled-components';
import MessageComposerSavedReplyItem from './SavedReplyItem';

const RepliesContainer = styled(Stack)`
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  overflow: auto;
  justify-content: flex-start;
  align-items: stretch;

  // Ensure the scrollbar is always visible
  margin-right: -${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(2, 4, 0, 0)};
  appearance: none;
  -webkit-appearance: none;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => alpha(theme.palette.primary.main, 0.2)};
    border-radius: 4px;
  }
`;

type Props = {
  savedReplies: SavedReply[];
  isLoading: boolean;
};

const SavedRepliesList: FC<Props> = ({ savedReplies, isLoading }) => (
  <RepliesContainer>
    {isLoading &&
      Array.from({ length: 3 }).map((_, index) => (
        <Skeleton
          variant="rectangular"
          height="100px"
          width="100%"
          sx={{ minHeight: '100px', minWidth: '100%', borderRadius: 1 }}
          key={index}
        />
      ))}
    {savedReplies.map((savedReply) => (
      <MessageComposerSavedReplyItem
        key={savedReply.id}
        savedReply={savedReply}
      />
    ))}
  </RepliesContainer>
);

export default SavedRepliesList;
